import env from '../../../../environment';
import {postCreator, putCreator} from '../../../../http';

export const endpoints = Object.freeze({
  OPEN_CONVERSATION: `${env.baseApiUrl}/im/admin/crm-messaging/conversation/initialization`,
  UPDATE_CONVERSATIONS: `${env.baseApiUrl}/im/admin/crm-messaging/conversation`,
  UPDATE_CONVERSATION: `${env.baseApiUrl}/im/admin/crm-messaging/conversation/:conversationId`,
});

export const openConversationApi = postCreator(endpoints.OPEN_CONVERSATION);
export const updateConversationsApi = putCreator(
  endpoints.UPDATE_CONVERSATIONS
);

export const updateConversationApi = putCreator(endpoints.UPDATE_CONVERSATION);
